import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

const breadcrumbs = {
  lastDirectory: htmlE`
    ${({ path, dirname }) => {
      const directoryUrl = utils.encodeURILocal(path);
      return `<li data-directory-url="${directoryUrl}">
      <div class="text-primaryMain is-flex is-align-items-center">
        <span class="icon is-small">
          <i class="icon-folder-close" aria-hidden="true"></i>
        </span>
        <span class="directory-name">${dirname}</span>
      </div>
    </li>`;
    }}
  `,
  nonRootTemplate: htmlE`
    ${({ path, dirname }) => {
      const directoryUrl = utils.encodeURILocal(path);
      return `<li data-directory-url="${directoryUrl}">
          <a class="text-primaryMain" href="#${directoryUrl}">
            <span class="icon is-small">
              <i class="icon-folder-close" aria-hidden="true"></i>
            </span>
            <span class="directory-name">${dirname}</span>
          </a>
        </li>`;
    }}
  `,
  rootTemplate: htmlE`
    <li data-directory-url="Home">
      <a class="text-primaryMain" href="#/">
        <span class="icon is-small">
          <i class="icon-home" aria-hidden="true"></i>
        </span>
        <span class="directory-name" data-i18n-key="home">
          ${"homeWordTranslation"}
        </span>
      </a>
    </li>
  `,
  rootTemplateCustom: htmlE`
    <li>
      <a class="text-primaryMain" href="#/">
        <span class="icon is-small">
          <i class="icon-home mr-1" aria-hidden="true"></i>
        </span>
        <span class="directory-name">${"customName"}</span>
      </a>
    </li>
  `,
  render: (hashListener, t, refreshListing, customRootName) => {
    const currentPath = hashListener.getPath();
    const dirs = currentPath.split("/");
    const crumbs = [];
    let items = 0;

    const homeWordTranslation = t("home");

    function getLocation(num) {
      let newLoc = "";
      for (let i = 0; i < num; i++) {
        newLoc += dirs[i] + "/";
      }
      return utils.decodeURILocal(newLoc);
    }

    for (let i = dirs.length - 1; i > 0; i--) {
      if (dirs[i]) {
        const dirname = utils.textEncode(dirs[i]);
        const path = getLocation(i + 1);

        if (i === dirs.length - 2) {
          crumbs.unshift(breadcrumbs.lastDirectory({ path, dirname }));
        } else {
          crumbs.unshift(breadcrumbs.nonRootTemplate({ path, dirname }));
        }
      }
      items += 1;
    }

    if (customRootName) {
      crumbs.unshift(
        breadcrumbs.rootTemplateCustom({ customName: customRootName })
      );
    } else {
      crumbs.unshift(breadcrumbs.rootTemplate({ homeWordTranslation }));
    }

    const breadcrumbsContainer = _$("#dashboard-breadcrumb ul");
    breadcrumbsContainer.html(crumbs.join(""));
    const lastLI = _$("#dashboard-breadcrumb").find("li:last-child").el();
    utils.generateHTML(
      [
        {
          type: "a.text-primaryMain.refresh-button.ml-2",
          attrs: {
            href: "#" + utils.encodeURILocal(currentPath),
            "aria-label": "Refresh current directory",
            title: "Refresh current directory",
          },
          children: [
            {
              type: "span.icon.is-small",
              children: [
                {
                  type: "i.icon-refresh.mr-1",
                },
              ],
            },
          ],
        },
      ],
      lastLI
    );

    if (breadcrumbsContainer.find(".refresh-button").length) {
      _$(breadcrumbsContainer.find(".refresh-button").el()).on(
        "click",
        (evt) => {
          evt.stopPropagation();
          evt.preventDefault();
          if (refreshListing) refreshListing.apply(this);
        }
      );
    }

    breadcrumbsContainer
      .find("li")
      .sel()
      .forEach((li) => {
        _$(li).on("click", (event) => {
          if (event.ctrlKey || event.metaKey) {
            // Prevent the anchor link from being triggered
            event.preventDefault();
            event.stopPropagation();

            // Copy data-directory-url to clipboard
            const directoryUrl = li.getAttribute("data-directory-url");
            if (directoryUrl) {
              navigator.clipboard
                .writeText(utils.decodeURILocal(directoryUrl))
                .then(() => {
                  console.log(
                    `Copied to clipboard: ${utils.decodeURILocal(directoryUrl)}`
                  );
                });
            }
          }
        });
      });
  },
};

export default breadcrumbs;
